import { render, staticRenderFns } from "./BlueBox.vue?vue&type=template&id=884139d8&scoped=true&"
import script from "./BlueBox.vue?vue&type=script&lang=js&"
export * from "./BlueBox.vue?vue&type=script&lang=js&"
import style0 from "./BlueBox.vue?vue&type=style&index=0&id=884139d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "884139d8",
  null
  
)

export default component.exports